import { FC } from "react";
import Icon from ".";
import { IconElementProps, createIconVariantMap } from "./Icon.types";

export const Filled12 = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M6 0.5C9.03759 0.5 11.4999 2.96242 11.5 6C11.5 9.03762 9.03762 11.5 6 11.5C2.96241 11.5 0.5 9.0376 0.5 6C0.500053 2.96245 2.96244 0.500036 6 0.5ZM5.9873 5.30078C5.65754 5.30078 5.38965 5.56901 5.38965 5.90039V8.30078C5.38984 8.632 5.65766 8.90039 5.9873 8.90039C6.31689 8.90031 6.58379 8.63195 6.58398 8.30078V5.90039C6.58398 5.56906 6.317 5.30086 5.9873 5.30078ZM5.9873 2.90039C5.65765 2.90039 5.38983 3.16878 5.38965 3.5C5.38965 3.83138 5.65754 4.10059 5.9873 4.10059H5.99316L6.05469 4.09766C6.35555 4.06671 6.58984 3.81051 6.58984 3.5C6.58967 3.18966 6.35543 2.93426 6.05469 2.90332L5.99316 2.90039H5.9873Z" fill="currentColor" />
    </svg>
  );
};

export const Filled16 = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M8 0.665039C12.051 0.665039 15.3349 3.949 15.335 8C15.335 12.0511 12.0511 15.335 8 15.335C3.949 15.3349 0.665039 12.051 0.665039 8C0.665131 3.94905 3.94905 0.665131 8 0.665039ZM7.9834 7.06641C7.54361 7.06641 7.18652 7.42525 7.18652 7.86719V11.0674C7.18652 11.5093 7.54361 11.8682 7.9834 11.8682C8.42298 11.8679 8.7793 11.5092 8.7793 11.0674V7.86719C8.7793 7.42541 8.42298 7.06666 7.9834 7.06641ZM7.9834 3.86621C7.54361 3.86621 7.18653 4.22408 7.18652 4.66602C7.18652 5.10795 7.54361 5.46582 7.9834 5.46582H7.99023L8.07227 5.46191C8.4738 5.42092 8.78711 5.08032 8.78711 4.66602C8.78711 4.25171 8.47379 3.91111 8.07227 3.87012L7.99023 3.86621H7.9834Z" fill="currentColor" />
    </svg>
  );
};

export const Filled20 = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M10.0005 0.833984C15.0629 0.83416 19.1665 4.93847 19.1665 10.001C19.1663 15.0633 15.0628 19.1668 10.0005 19.167C4.93799 19.167 0.833672 15.0634 0.833496 10.001C0.833496 4.93837 4.93788 0.833984 10.0005 0.833984ZM9.979 8.83398C9.4294 8.83398 8.98389 9.2817 8.98389 9.83398V13.834C8.98389 14.3863 9.4294 14.834 9.979 14.834C10.5284 14.8338 10.9741 14.3861 10.9741 13.834V9.83398C10.9741 9.28183 10.5284 8.83419 9.979 8.83398ZM9.979 4.83398C9.4294 4.83398 8.98389 5.2817 8.98389 5.83398C8.98389 6.38627 9.4294 6.83398 9.979 6.83398H9.98877L10.0903 6.8291C10.5921 6.77788 10.9839 6.35174 10.9839 5.83398C10.9839 5.31623 10.5921 4.89009 10.0903 4.83887L9.98877 4.83398H9.979Z" fill="currentColor" />
    </svg>
  );
};

export const Outlined12 = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_6165_14921)">
        <path d="M6 0.5C9.03759 0.5 11.4999 2.96242 11.5 6C11.5 9.03762 9.03762 11.5 6 11.5C2.9624 11.5 0.5 9.0376 0.5 6C0.500053 2.96244 2.96244 0.500028 6 0.5ZM6 1.5C3.51473 1.50003 1.50005 3.51474 1.5 6C1.5 8.48531 3.5147 10.5 6 10.5C8.48533 10.5 10.5 8.48533 10.5 6C10.4999 3.51472 8.48529 1.5 6 1.5ZM5.9873 5.30078C6.31699 5.30088 6.58398 5.56907 6.58398 5.90039V8.30078C6.58379 8.63194 6.31687 8.9003 5.9873 8.90039C5.65766 8.90039 5.38984 8.632 5.38965 8.30078V5.90039C5.38965 5.56901 5.65754 5.30078 5.9873 5.30078ZM6.05371 2.90332C6.35468 2.93404 6.58967 3.1895 6.58984 3.5C6.58984 3.81066 6.35479 4.06692 6.05371 4.09766L5.99316 4.10059H5.9873C5.65754 4.10059 5.38965 3.83138 5.38965 3.5C5.38983 3.16878 5.65765 2.90039 5.9873 2.90039H5.99316L6.05371 2.90332Z" fill="currentColor" />
      </g>
      <defs>
        <clipPath id="clip0_6165_14921">
          <rect width="12" height="12" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const Outlined16 = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_6165_14919)">
        <path d="M8 0.665039C12.051 0.665039 15.3349 3.949 15.335 8C15.335 12.0511 12.0511 15.335 8 15.335C3.949 15.3349 0.665039 12.051 0.665039 8C0.665131 3.94905 3.94905 0.665131 8 0.665039ZM8 1.99902C4.68561 1.99912 1.99912 4.68561 1.99902 8C1.99902 11.3145 4.68556 14.0019 8 14.002C11.3145 14.002 14.002 11.3145 14.002 8C14.0019 4.68556 11.3145 1.99902 8 1.99902ZM7.9834 7.06641C8.42298 7.06666 8.7793 7.42541 8.7793 7.86719V11.0674C8.7793 11.5092 8.42298 11.8679 7.9834 11.8682C7.54361 11.8682 7.18652 11.5093 7.18652 11.0674V7.86719C7.18652 7.42525 7.54361 7.06641 7.9834 7.06641ZM8.07227 3.87012C8.47379 3.91111 8.78711 4.25171 8.78711 4.66602C8.78711 5.08032 8.4738 5.42092 8.07227 5.46191L7.99023 5.46582H7.9834C7.54361 5.46582 7.18652 5.10795 7.18652 4.66602C7.18653 4.22408 7.54361 3.86621 7.9834 3.86621H7.99023L8.07227 3.87012Z" fill="currentColor" />
      </g>
      <defs>
        <clipPath id="clip0_6165_14919">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const Outlined20 = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_6165_14917)">
        <path d="M10.0005 0.833984C15.063 0.83416 19.1665 4.93847 19.1665 10.001C19.1663 15.0633 15.0628 19.1668 10.0005 19.167C4.93799 19.167 0.833672 15.0634 0.833496 10.001C0.833496 4.93837 4.93788 0.833984 10.0005 0.833984ZM10.0005 2.50098C5.85835 2.50098 2.50049 5.85884 2.50049 10.001C2.50066 14.143 5.85846 17.501 10.0005 17.501C14.1424 17.5008 17.5003 14.1429 17.5005 10.001C17.5005 5.85895 14.1425 2.50115 10.0005 2.50098ZM9.979 8.83398C10.5284 8.83418 10.9741 9.28182 10.9741 9.83398V13.834C10.9741 14.3861 10.5284 14.8338 9.979 14.834C9.4294 14.834 8.98389 14.3863 8.98389 13.834V9.83398C8.98389 9.2817 9.4294 8.83398 9.979 8.83398ZM10.0903 4.83887C10.5921 4.89009 10.9839 5.31623 10.9839 5.83398C10.9839 6.35174 10.5921 6.77788 10.0903 6.8291L9.98877 6.83398H9.979C9.4294 6.83398 8.98389 6.38627 8.98389 5.83398C8.98389 5.2817 9.4294 4.83398 9.979 4.83398H9.98877L10.0903 4.83887Z" fill="currentColor" />
      </g>
      <defs>
        <clipPath id="clip0_6165_14917">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const variants = createIconVariantMap({
  filled: {
    12: Filled12,
    16: Filled16,
    20: Filled20,
  },
  outlined: {
    12: Outlined12,
    16: Outlined16,
    20: Outlined20,
  },
});

export const IconInfoCircle: FC<IconElementProps & { className?: string }> = (props) => (
  <Icon name={"info-circle"} {...props} />
);
